import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_MIN_WIDTH } from './breakpoints';

export function useIsDesktop(): boolean {
  return useMediaQuery({ query: MEDIA_QUERY_MIN_WIDTH.lg });
}
